import React , { Component } from 'react';
import { par1, par2, par3, par4, par5 } from '../data/Text/mainText.js';
import '../css/BisharatMain.css'


export default class AboutUs extends Component {

render() {
  return (
    <div className="top-level-page-main aboutus">

      <div className="aboutus-main">
       
        <div className="aboutus-paraghs">
        <h1> كلمة الموقع </h1>
        {par1} <br />
        {par2} <br />
        {par3} <br />
        {par4} <br />
        {par5} <br />
        </div>
        <div className="about-us-subtitle">
        <h2>
        مع فائق الاحترام والمودة
        <br/>
        جريس خليل بشارات
        <br/>
        يافة الناصرة
        </h2>
        <br/>
  
        {/* <h3> لا يجوز تناقل او استخدام محتواه دون اذن</h3> */}
        </div>

  <div>
  {/* <a href="/family-aboutus/JPage">صاحب ومصمم الموقع</a> */}
  </div>


      </div>
      
      </div>


  
  );
};
}